<!--
    @name: widget-modelView
    @description：widget-modelView
    @author: ZengWei
    @date: 2022-03-25 09:43
-->
<template>
  <ChooseModel
    ref="chooseView"
    chooseType="view"
    @set-data="setModelData"
    :search="searchData"
    :modelData="element.value && element.value != null? element.value: []">
    <template v-slot:showType>
      <el-button
        style="width: 100%"
        @click="openModelDrawer('chooseView')"
        size="medium"
        type="primary"
        v-html="
          element.value && element.value != null && element.value.length != 0
          ? '已选择': '请选择'"
      ></el-button>
    </template>
  </ChooseModel>
</template>

<script>
import ChooseModel from "@/custom-component/bindModel/ButtonType.vue";
import formItemMinix from "@/custom-component/form/newParser/scripts/formItemMinix";
import eventBus from "@/plugins/eventBus";
import {getSearchData} from "@/custom-component/form/newParser/scripts/tools";

export default {
  name: "WidgetModelView",
  components: {ChooseModel},
  mixins: [formItemMinix],
  props: ['element', 'disabled', 'displayData'],
  data() {
    return {
      searchData: []
    }
  },
  created() {
    this.initSearch();
  },
  mounted() {
    eventBus.$on('TRIGGER_selectChange',(formId)=>{
      const eleConf = this.element.config.__config__;
      const filterRule = eleConf?.filterRule || []
      const formIdArr = filterRule.filter(item => item.valueType === 2)
      const compFormId = Array.from(formIdArr,item => item.value)
      if(compFormId.includes(formId)){
        this.initSearch();
      }
    })
  },
  methods: {
    initSearch(){
      const filterOpen = this.element.config.__config__?.openFilter ?? false
      const filterRule = this.element.config.__config__?.filterRule ?? []
      if(filterOpen && filterRule.length>0){
        this.searchData = getSearchData(filterRule,this.parser.getFormIdValue);
      }
    },
    openModelDrawer() {
      this.$nextTick(() => {
        this.$refs[name].show = true;
      })
    },
    setModelData(data) {
      this.element.value = data;
    },
  },
}
</script>

<style scoped>

</style>
